import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Computers used to work in the 90's",
  "description": "",
  "published": "2008-09-04T00:00:00.000Z",
  "redirect_from": ["/blog/computers-used-to-work-in-the-90s/swizec/75"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Have you ever noticed how back in the old days of everyday computing computers used to just work? Bugs were unheard of, crashes never happened and everyone was happy. Nowadays it would seem everyone simply works around the bugs because they're expected and part of our everyday lives, crashing happens so often even your 70 year old grandfather knows he simply has to press The Key Combination and memory leaks are so commonplace everyone and their mother reboots computers when they get kind of slowish.`}</p>
    <p>{`But why is this? WHY I ask? Why is it that with computer science booming like never before, with thousands of talented young programmers, with dozens of old tricks up everyone's sleeves, computers and their software just keep getting worse and worse? Bad design decisions are being made every day, bugs are solved years too late, sometimes never, and crashing is becoming so common certain software is just taking it for granted and is designed to work around crashes (I'm looking at you Google Chrome and IE8!). Why does this seem necessary? Is it really so much easier to make software work around bugs rather than resovling the bloody bugs in the first place?`}</p>
    <p>{`The system is broken, computers are going to hell, and users have simply learnt to live with it. This makes me sad.`}</p>
    <p><img parentName="p" {...{
        "src": "/computers.jpg",
        "alt": " ",
        "title": "Computers poster"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      